import styled from 'styled-components'

import NavLink from '../../components/NavLink'
import NutritionalFactsTable from '../../components/NutritionalFactsTable'
import { BREAKPOINTS, COLORS, media, THEME, typeScale } from '../../styles'

const Styled = styled.div`
  background: ${THEME.COLORS.background.primary};
`
Styled.header = styled.header`
  background-color: ${THEME.COLORS.background.primary};
  padding: 2.4rem;
  text-align: center;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  ${media.medium`
    padding: 3.6rem;
  `}
`
Styled.page = styled.div`
  padding: 1.6rem;
  ${media.medium`
    padding: 3.6rem 6.4rem 6.4rem;
  `}
`
Styled.content = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${BREAKPOINTS.xxxLarge};
  display: flex;
  flex-flow: column nowrap;
  ${media.medium`
    flex-flow: row nowrap;
  `}
`
Styled.ingredient = styled.div`
  ${media.medium`
    flex: 0 0 36rem;
  `}
`
Styled.recipes = styled.div`
  flex: 1;
  ${media.medium`
    padding-left: 7.2rem;
  `}
`
Styled.title = styled.h1`
  ${typeScale('headline2')}
  padding-bottom: 0.8rem;

  ${media.medium`
    ${typeScale('headline1')}
  `}
  strong {
    color: ${COLORS.kale};
  }
`
Styled.description = styled.p`
  padding-bottom: 2.4rem;
`
Styled.discover = styled(NavLink)`
  ${typeScale('button')};
  border: none;
  cursor: pointer;
  margin: 0;
  position: relative;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  border-radius: 5.6rem;
  height: 5.6rem;
  line-height: 5.6rem;
  background-color: ${COLORS.primary};
  padding-left: 4.8rem;
  padding-right: 4.8rem;
  color: ${COLORS.white};
  transition: background-color 0.2s ease-out;
`
Styled.ingredientName = styled.h2`
  ${typeScale('headline2')}
  text-align: center;
  padding-bottom: 0.8rem;
`
Styled.ingredientDescription = styled.p``
Styled.discoverJow = styled(Styled.discover)`
  width: 100%;
`
Styled.nutritionalFacts = styled(NutritionalFactsTable)`
  margin: 3.2rem 0;
`
Styled.nutritionalFactsTitle = styled.h3`
  ${typeScale('headline3')}
  text-align: center;
  color: ${THEME.COLORS.foreground.secondary};
  padding-bottom: 0.4rem;
  padding-top: 1.6rem;
`
Styled.nutritionalFactsExplanation = styled.p`
  text-align: center;
  color: ${THEME.COLORS.foreground.secondary};
`
Styled.image = styled.div`
  margin: 0 auto;
  width: 12.8rem;
  height: 12.8rem;
  border-radius: 9999px;
  overflow: hidden;
`

export default Styled
